/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * События помещений
 */

/**
 * Справочник статусов удаления ключа со всех устройств.
 */
export enum DeleteRfidsFromAllDevicesResultTaskStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Настроен
   */
  SUCCESS = "SUCCESS",
  /**
   * Ошибка
   */
  ERROR = "ERROR",
}
/**
 * Справочник статусов удаления ключа со всех устройств.
 */
export type DeleteRfidsFromAllDevicesResultTaskStatusTypeResponseEnum = keyof typeof DeleteRfidsFromAllDevicesResultTaskStatusType
/**
 * Справочник статусов удаления ключа со всех устройств.
 */
export type DeleteRfidsFromAllDevicesResultTaskStatusTypeRequestEnum = Exclude<DeleteRfidsFromAllDevicesResultTaskStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Тип проигрывания.
 */
export enum PrepareStartTaskPlayType {
  /**
   * Значение не указано
   */
  PLAY_TYPE_UNKNOWN = "PLAY_TYPE_UNKNOWN",
  /**
   * Только на аналоговые трубки
   */
  HANDSET_ONLY = "HANDSET_ONLY",
  /**
   * Tолько на динамик домофона
   */
  SPEAKER_ONLY = "SPEAKER_ONLY",
  /**
   * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
   */
  HANDSET_AND_SPEAKER = "HANDSET_AND_SPEAKER",
  /**
   * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
   */
  SPEAKER_AND_HANDSET = "SPEAKER_AND_HANDSET",
}
/**
 * Тип проигрывания.
 */
export type PrepareStartTaskPlayTypeResponseEnum = keyof typeof PrepareStartTaskPlayType
/**
 * Тип проигрывания.
 */
export type PrepareStartTaskPlayTypeRequestEnum = Exclude<PrepareStartTaskPlayTypeResponseEnum, "PLAY_TYPE_UNKNOWN">;

/**
 * Задача на активацию аналоговых трубок квартир для устройства на доме.
 * Очередь key.access_control.activate_cms
 */
export type ActivateCmsSettingsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номера квартир с включенным режимом подписок, у которых блокируется аналоговая трубка
   */
  roomNumbers: string[]
}
/**
 * Задача на активацию аналоговых трубок квартир для устройства на доме.
 * Очередь key.access_control.activate_cms
 */
export type ActivateCmsSettingsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номера квартир с включенным режимом подписок, у которых блокируется аналоговая трубка
   */
  roomNumbers: string[]
}
/**
 * Задача на блокировку аналоговых трубок квартир для устройства на доме.
 * Очередь key.access_control.block_cms
 */
export type BlockCmsSettingsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номера квартир с включенным режимом подписок, у которых активируется аналоговая трубка
   */
  roomNumbers: string[]
}
/**
 * Задача на блокировку аналоговых трубок квартир для устройства на доме.
 * Очередь key.access_control.block_cms
 */
export type BlockCmsSettingsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номера квартир с включенным режимом подписок, у которых активируется аналоговая трубка
   */
  roomNumbers: string[]
}
/**
 * Задача ответ на конфигурацию квартир.
 * Очередь key.access_control.configure_rooms_result
 */
export type ConfigureRoomsResultTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Список квартир с результатом конфигурации
   */
  rooms: ConfigureRoomsResultTaskRoomRequestDto[]
}
/**
 * Задача ответ на конфигурацию квартир.
 * Очередь key.access_control.configure_rooms_result
 */
export type ConfigureRoomsResultTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Список квартир с результатом конфигурации
   */
  rooms: ConfigureRoomsResultTaskRoomResponseDto[]
}
/**
 * Результат конфигурации квартиры
 */
export type ConfigureRoomsResultTaskRoomRequestDto = {
  /**
   * Идентификатор квартиры
   */
  roomId: number
  /**
   * Признак \"Сконфигурировано\"
   */
  isConfigured: boolean
  /**
   * Текст ошибки
   */
  errorMessage?: string
}
/**
 * Результат конфигурации квартиры
 */
export type ConfigureRoomsResultTaskRoomResponseDto = {
  /**
   * Идентификатор квартиры
   */
  roomId: number
  /**
   * Признак \"Сконфигурировано\"
   */
  isConfigured: boolean
  /**
   * Текст ошибки
   */
  errorMessage: string
}
/**
 * Задача на удаление кодов с устройств.
 * Очередь key.access_control.delete_codes_from_devices
 */
export type DeleteCodesFromDevicesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список кодов
   */
  codes: DeleteCodesFromDevicesTaskCodeRequestDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
  /**
   * Удаление без ожидания ответа от устройства
   */
  isForceDelete?: boolean | null
}
/**
 * Задача на удаление кодов с устройств.
 * Очередь key.access_control.delete_codes_from_devices
 */
export type DeleteCodesFromDevicesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список кодов
   */
  codes: DeleteCodesFromDevicesTaskCodeResponseDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
  /**
   * Удаление без ожидания ответа от устройства
   */
  isForceDelete: boolean | null
}
/**
 * Код
 */
export type DeleteCodesFromDevicesTaskCodeRequestDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Код
 */
export type DeleteCodesFromDevicesTaskCodeResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Результат задачи на удаление ключа со всех устройств.
 * Очередь key.access_control.delete_rfids_from_all_devices_result
 */
export type DeleteRfidsFromAllDevicesResultTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ключа
   */
  rfidId: number
  /**
   * Статус удаления ключа со всех устройств
   */
  statusType: DeleteRfidsFromAllDevicesResultTaskStatusTypeRequestEnum
}
/**
 * Результат задачи на удаление ключа со всех устройств.
 * Очередь key.access_control.delete_rfids_from_all_devices_result
 */
export type DeleteRfidsFromAllDevicesResultTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ключа
   */
  rfidId: number
  /**
   * Статус удаления ключа со всех устройств
   */
  statusType: DeleteRfidsFromAllDevicesResultTaskStatusTypeResponseEnum
}
/**
 * Задача на удаление ключей со всех устройств.
 * Очередь key.access_control.delete_rfids_from_all_devices
 */
export type DeleteRfidsFromAllDevicesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список ключей
   */
  rfids: DeleteRfidsFromAllDevicesTaskRfidRequestDto[]
  /**
   * Удаление без ожидания ответа от устройства
   */
  isForceDelete?: boolean | null
}
/**
 * Задача на удаление ключей со всех устройств.
 * Очередь key.access_control.delete_rfids_from_all_devices
 */
export type DeleteRfidsFromAllDevicesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список ключей
   */
  rfids: DeleteRfidsFromAllDevicesTaskRfidResponseDto[]
  /**
   * Удаление без ожидания ответа от устройства
   */
  isForceDelete: boolean | null
}
/**
 * Ключ
 */
export type DeleteRfidsFromAllDevicesTaskRfidRequestDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Ключ
 */
export type DeleteRfidsFromAllDevicesTaskRfidResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Задача на удаление ключей с устройств.
 * Очередь key.access_control.delete_rfids_from_devices
 */
export type DeleteRfidsFromDevicesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список ключей
   */
  rfids: DeleteRfidsFromDevicesTaskRfidRequestDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
  /**
   * Удаление без ожидания ответа от устройства
   */
  isForceDelete?: boolean | null
}
/**
 * Задача на удаление ключей с устройств.
 * Очередь key.access_control.delete_rfids_from_devices
 */
export type DeleteRfidsFromDevicesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список ключей
   */
  rfids: DeleteRfidsFromDevicesTaskRfidResponseDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
  /**
   * Удаление без ожидания ответа от устройства
   */
  isForceDelete: boolean | null
}
/**
 * Ключ
 */
export type DeleteRfidsFromDevicesTaskRfidRequestDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Ключ
 */
export type DeleteRfidsFromDevicesTaskRfidResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Задача на активацию аналоговых трубок квартир для устройства на доме без дополнительных проверок на устройстве.
 * Очередь key.access_control.force_activate_cms
 */
export type ForceActivateCmsSettingsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номера квартир для которых необходимо активация аналоговых трубок
   */
  roomNumbers: string[]
}
/**
 * Задача на активацию аналоговых трубок квартир для устройства на доме без дополнительных проверок на устройстве.
 * Очередь key.access_control.force_activate_cms
 */
export type ForceActivateCmsSettingsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Идентификатор ОРПОН дома
   */
  orponId: string
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Номера квартир для которых необходимо активация аналоговых трубок
   */
  roomNumbers: string[]
}
/**
 * Задача на добавление кодов на устройства.
 * Очередь key.access_control.load_codes_to_devices
 */
export type LoadCodesToDevicesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список кодов
   */
  codes: LoadCodesToDevicesTaskCodeRequestDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
}
/**
 * Задача на добавление кодов на устройства.
 * Очередь key.access_control.load_codes_to_devices
 */
export type LoadCodesToDevicesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список кодов
   */
  codes: LoadCodesToDevicesTaskCodeResponseDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
}
/**
 * Код
 */
export type LoadCodesToDevicesTaskCodeRequestDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Код
 */
export type LoadCodesToDevicesTaskCodeResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение кода
   */
  code: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Задача на добавление ключей на устройства.
 * Очередь key.access_control.load_rfids_to_devices
 */
export type LoadRfidsToDevicesTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список ключей
   */
  rfids: LoadRfidsToDevicesTaskRfidRequestDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
}
/**
 * Задача на добавление ключей на устройства.
 * Очередь key.access_control.load_rfids_to_devices
 */
export type LoadRfidsToDevicesTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Список ключей
   */
  rfids: LoadRfidsToDevicesTaskRfidResponseDto[]
  /**
   * Список идентификаторов устройств
   */
  deviceIds: number[]
}
/**
 * Ключ
 */
export type LoadRfidsToDevicesTaskRfidRequestDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Ключ
 */
export type LoadRfidsToDevicesTaskRfidResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Значение ключа
   */
  key: string
  /**
   * Номер квартиры
   */
  roomNumber: string
  /**
   * Идентификатор квартиры
   */
  roomId: number
}
/**
 * Команда на подготовку и старт оповещения через домофоны.
 * Очередь key.access_control.alert.prepare_start
 */
export type PrepareStartTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 2..100
   */
  soundFileUri: string
  /**
   * Идентификатор ОРПОН дома, на котором запускаем проигрывание
   */
  orpon: string
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PrepareStartTaskPlayTypeRequestEnum
}
/**
 * Команда на подготовку и старт оповещения через домофоны.
 * Очередь key.access_control.alert.prepare_start
 */
export type PrepareStartTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Ссылка на звуковой файл для проигрывания.
   * Файл должен лежать на внутреннем хранилище.
   * # Диапазон: 2..100
   */
  soundFileUri: string
  /**
   * Идентификатор ОРПОН дома, на котором запускаем проигрывание
   */
  orpon: string
  /**
   * Длительность воспроизведения такта в секундах.
   * Такт включает в себя проигрывание файла на трубках или на динамике.
   * # Диапазон: 0..65536
   */
  tactPlayDuration: number
  /**
   * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
   * # Диапазон: 0..65536
   */
  tactRepeatCount: number
  /**
   * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
   * # Диапазон: 0..65536
   */
  playRepeatCount: number
  /**
   * Тип проигрывания
   */
  playType: PrepareStartTaskPlayTypeResponseEnum
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача на активацию аналоговых трубок квартир для устройства на доме.
   * Очередь key.access_control.activate_cms
   */
  "ActivateCmsSettingsTask": {
    "kind": "class",
    "text": "Задача на активацию аналоговых трубок квартир для устройства на доме.\nОчередь key.access_control.activate_cms",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номера квартир с включенным режимом подписок, у которых блокируется аналоговая трубка
       */
      "roomNumbers": {
        "type": "string",
        "text": "Номера квартир с включенным режимом подписок, у которых блокируется аналоговая трубка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на блокировку аналоговых трубок квартир для устройства на доме.
   * Очередь key.access_control.block_cms
   */
  "BlockCmsSettingsTask": {
    "kind": "class",
    "text": "Задача на блокировку аналоговых трубок квартир для устройства на доме.\nОчередь key.access_control.block_cms",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номера квартир с включенным режимом подписок, у которых активируется аналоговая трубка
       */
      "roomNumbers": {
        "type": "string",
        "text": "Номера квартир с включенным режимом подписок, у которых активируется аналоговая трубка",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача ответ на конфигурацию квартир.
   * Очередь key.access_control.configure_rooms_result
   */
  "ConfigureRoomsResultTask": {
    "kind": "class",
    "text": "Задача ответ на конфигурацию квартир.\nОчередь key.access_control.configure_rooms_result",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список квартир с результатом конфигурации
       */
      "rooms": {
        "type": "ConfigureRoomsResultTask.Room",
        "text": "Список квартир с результатом конфигурации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Результат конфигурации квартиры
   */
  "ConfigureRoomsResultTask.Room": {
    "kind": "class",
    "text": "Результат конфигурации квартиры",
    "fields": {
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Признак \"Сконфигурировано\"
       */
      "isConfigured": {
        "type": "bool",
        "text": "Признак \"Сконфигурировано\"",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "string",
        "text": "Текст ошибки",
      },
    },
  },
  /**
   * Задача на удаление кодов с устройств.
   * Очередь key.access_control.delete_codes_from_devices
   */
  "DeleteCodesFromDevicesTask": {
    "kind": "class",
    "text": "Задача на удаление кодов с устройств.\nОчередь key.access_control.delete_codes_from_devices",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список кодов
       */
      "codes": {
        "type": "DeleteCodesFromDevicesTask.Code",
        "text": "Список кодов",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список идентификаторов устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "Список идентификаторов устройств",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Удаление без ожидания ответа от устройства
       */
      "isForceDelete": {
        "type": "google.protobuf.BoolValue",
        "text": "Удаление без ожидания ответа от устройства",
      },
    },
  },
  /**
   * Код
   */
  "DeleteCodesFromDevicesTask.Code": {
    "kind": "class",
    "text": "Код",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение кода
       */
      "code": {
        "type": "string",
        "text": "Значение кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Результат задачи на удаление ключа со всех устройств.
   * Очередь key.access_control.delete_rfids_from_all_devices_result
   */
  "DeleteRfidsFromAllDevicesResultTask": {
    "kind": "class",
    "text": "Результат задачи на удаление ключа со всех устройств.\nОчередь key.access_control.delete_rfids_from_all_devices_result",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ключа
       */
      "rfidId": {
        "type": "int32",
        "text": "Идентификатор ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Статус удаления ключа со всех устройств
       */
      "statusType": {
        "type": "DeleteRfidsFromAllDevicesResultTask.StatusType",
        "text": "Статус удаления ключа со всех устройств",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на удаление ключей со всех устройств.
   * Очередь key.access_control.delete_rfids_from_all_devices
   */
  "DeleteRfidsFromAllDevicesTask": {
    "kind": "class",
    "text": "Задача на удаление ключей со всех устройств.\nОчередь key.access_control.delete_rfids_from_all_devices",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список ключей
       */
      "rfids": {
        "type": "DeleteRfidsFromAllDevicesTask.Rfid",
        "text": "Список ключей",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Удаление без ожидания ответа от устройства
       */
      "isForceDelete": {
        "type": "google.protobuf.BoolValue",
        "text": "Удаление без ожидания ответа от устройства",
      },
    },
  },
  /**
   * Ключ
   */
  "DeleteRfidsFromAllDevicesTask.Rfid": {
    "kind": "class",
    "text": "Ключ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на удаление ключей с устройств.
   * Очередь key.access_control.delete_rfids_from_devices
   */
  "DeleteRfidsFromDevicesTask": {
    "kind": "class",
    "text": "Задача на удаление ключей с устройств.\nОчередь key.access_control.delete_rfids_from_devices",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список ключей
       */
      "rfids": {
        "type": "DeleteRfidsFromDevicesTask.Rfid",
        "text": "Список ключей",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список идентификаторов устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "Список идентификаторов устройств",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Удаление без ожидания ответа от устройства
       */
      "isForceDelete": {
        "type": "google.protobuf.BoolValue",
        "text": "Удаление без ожидания ответа от устройства",
      },
    },
  },
  /**
   * Ключ
   */
  "DeleteRfidsFromDevicesTask.Rfid": {
    "kind": "class",
    "text": "Ключ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на активацию аналоговых трубок квартир для устройства на доме без дополнительных проверок на устройстве.
   * Очередь key.access_control.force_activate_cms
   */
  "ForceActivateCmsSettingsTask": {
    "kind": "class",
    "text": "Задача на активацию аналоговых трубок квартир для устройства на доме без дополнительных проверок на устройстве.\nОчередь key.access_control.force_activate_cms",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номера квартир для которых необходимо активация аналоговых трубок
       */
      "roomNumbers": {
        "type": "string",
        "text": "Номера квартир для которых необходимо активация аналоговых трубок",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на добавление кодов на устройства.
   * Очередь key.access_control.load_codes_to_devices
   */
  "LoadCodesToDevicesTask": {
    "kind": "class",
    "text": "Задача на добавление кодов на устройства.\nОчередь key.access_control.load_codes_to_devices",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список кодов
       */
      "codes": {
        "type": "LoadCodesToDevicesTask.Code",
        "text": "Список кодов",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список идентификаторов устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "Список идентификаторов устройств",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Код
   */
  "LoadCodesToDevicesTask.Code": {
    "kind": "class",
    "text": "Код",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение кода
       */
      "code": {
        "type": "string",
        "text": "Значение кода",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Задача на добавление ключей на устройства.
   * Очередь key.access_control.load_rfids_to_devices
   */
  "LoadRfidsToDevicesTask": {
    "kind": "class",
    "text": "Задача на добавление ключей на устройства.\nОчередь key.access_control.load_rfids_to_devices",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список ключей
       */
      "rfids": {
        "type": "LoadRfidsToDevicesTask.Rfid",
        "text": "Список ключей",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список идентификаторов устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "Список идентификаторов устройств",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ключ
   */
  "LoadRfidsToDevicesTask.Rfid": {
    "kind": "class",
    "text": "Ключ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение ключа
       */
      "key": {
        "type": "string",
        "text": "Значение ключа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор квартиры
       */
      "roomId": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Команда на подготовку и старт оповещения через домофоны.
   * Очередь key.access_control.alert.prepare_start
   */
  "PrepareStartTask": {
    "kind": "class",
    "text": "Команда на подготовку и старт оповещения через домофоны.\nОчередь key.access_control.alert.prepare_start",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ссылка на звуковой файл для проигрывания.
       * Файл должен лежать на внутреннем хранилище.
       * # Диапазон: 2..100
       */
      "soundFileUri": {
        "type": "string",
        "text": "Ссылка на звуковой файл для проигрывания.\nФайл должен лежать на внутреннем хранилище.\n# Диапазон: 2..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 2,
            "message": "Значение не входит в допустимый диапазон. Минимум: 2"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Идентификатор ОРПОН дома, на котором запускаем проигрывание
       */
      "orpon": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома, на котором запускаем проигрывание",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Длительность воспроизведения такта в секундах.
       * Такт включает в себя проигрывание файла на трубках или на динамике.
       * # Диапазон: 0..65536
       */
      "tactPlayDuration": {
        "type": "int32",
        "text": "Длительность воспроизведения такта в секундах.\nТакт включает в себя проигрывание файла на трубках или на динамике.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.
       * # Диапазон: 0..65536
       */
      "tactRepeatCount": {
        "type": "int32",
        "text": "Количество последовательных повторов тактов перед сменой динамика на трубки или наоборот.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.
       * # Диапазон: 0..65536
       */
      "playRepeatCount": {
        "type": "int32",
        "text": "Количество дополнительных повторов тактов, т.е. умолчание=0 - это проигрывание одного такта.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Тип проигрывания
       */
      "playType": {
        "type": "PrepareStartTask.PlayType",
        "text": "Тип проигрывания",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник статусов удаления ключа со всех устройств.
   */
  "DeleteRfidsFromAllDevicesResultTask.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов удаления ключа со всех устройств.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Настроен
       */
      "SUCCESS": {
        "i": 1,
        "text": "Настроен",
      },
      /**
       * Ошибка
       */
      "ERROR": {
        "i": 2,
        "text": "Ошибка",
      },
    },
  },
  /**
   * Тип проигрывания.
   */
  "PrepareStartTask.PlayType": {
    "kind": "enum",
    "text": "Тип проигрывания.",
    "values": {
      /**
       * Значение не указано
       */
      "PLAY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Только на аналоговые трубки
       */
      "HANDSET_ONLY": {
        "i": 1,
        "text": "Только на аналоговые трубки",
      },
      /**
       * Tолько на динамик домофона
       */
      "SPEAKER_ONLY": {
        "i": 2,
        "text": "Tолько на динамик домофона",
      },
      /**
       * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
       */
      "HANDSET_AND_SPEAKER": {
        "i": 3,
        "text": "Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона",
      },
      /**
       * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
       */
      "SPEAKER_AND_HANDSET": {
        "i": 4,
        "text": "Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки",
      },
    },
  },
}